module.exports = __webpack_public_path__ + "static/media/Prism grid view.5a7246e4.png";